import ball from './ball.png'
import bg from './bg1.jpg'
import calendar from './calendar.png'
import calendar2 from './calendar2.png'
import fb from './fb.png'
import ig from './ig.png'
import leftArrow from './leftArrow.png'
import marker from './marker.png'
import medal from './medal.png'
import medal2 from './medal2.png'
import playerIcon from './playerIcon.png'
import stadium from './stadium.png'
import star from './star.png'
import twitter from './Twitter.png'
import website from './website.png'
import yt from './yt.png'
import x from './x.png'
import heart from './heart.png'
import fullHeart from './heart1.png'
import burger from './burger.png'

export const IMAGES = {
    ball: ball,
    bg: bg,
    calendar: calendar,
    calendar2: calendar2,
    fb:fb,
    ig:ig,
    leftArrow:leftArrow,
    marker:marker,
    medal:medal,
    medal2:medal2,
    playerIcon:playerIcon,
    stadium:stadium,
    star:star,
    twitter:twitter,
    website:website,
    yt:yt,
    close: x,
    burger: burger,
    heart: heart,
    favourite: fullHeart
};
